/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Events_ConfirmInputs */



/**
* | output |
* | --- |
* | "Would you like to paste the event(s) based on the current time?" |
*
* @param {Paste_Events_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_events_confirm = /** @type {((inputs?: Paste_Events_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Events_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Souhaitez-vous coller le(s) événement(s) en fonction du temps actuel ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Möchten Sie die Ereignisse basierend auf der aktuellen Uhrzeit einfügen?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Desideri incollare l'evento/gli eventi in base all'ora corrente?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Хотите вставить событие(я) в соответствии с текущим временем?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Quieres pegar el(los) evento(s) según la hora actual?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您想根据当前时间粘贴事件吗？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在の時刻に基づいてイベントを貼り付けますか?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्या आप वर्तमान समय के आधार पर इवेंट्स को पेस्ट करना चाहेंगे?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Deseja colar os eventos com base na hora atual?")
	return /** @type {LocalizedString} */ ("Would you like to paste the event(s) based on the current time?")
});